import React, { useState, useEffect } from 'react';
import { Button, Card, Drawer } from 'antd';
import documents from './data';
import styles from './DocumentDrawer.module.css';
import { Pagination } from 'antd';


const DocumentDrawer = () => {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const total = documents.length;
  const pageSize = 15;

  const bodyStyle = {
    padding: 0,
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
  };

  const bodyCardStyle = {
    display: 'flex',
    flexDirection: 'column',
    height: '100%'
  }

  const paginate = (data, page = 1, limit = pageSize) => {
    const paginatedData = documents.slice((page - 1) * limit, page * limit);
    return paginatedData;
  };

  useEffect(() => {
    setData(paginate(documents, page));
  }, [page]);

  return (
    <div>
      <Button
        type="secondary"
        className="documentsFormBtn"
        onClick={ () => setVisible(true) }
      >
        Формы документов
      </Button>
      <Drawer
        visible={ visible }
        placement={ 'left' }
        close={ () => setVisible(false) }
        width={ 800 }
        closable={ false }
        onClose={ () => setVisible(false) }
        bodyStyle={ bodyStyle }
      >
        <div className={ styles.header }>
          <div className={ styles.header_title }>
            Типовые документы
          </div>
          { visible &&
          <Button
            shape="circle"
            icon="close"
            className={ styles.header_close }
            onClick={ () => setVisible(false) }
            size={ 'large' }
          />
          }
        </div>
        <div className={ styles.body }>
          <Card
            bodyStyle={bodyCardStyle}
            className={styles.card}
          >
            <div className={styles.body_content}>
              { data.map((item, index) => (
                <div
                  className="legalDoc__file"
                  key={ index }
                >
                  <a
                    href={ item.src }
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    { item.title }
                  </a>
                </div>
              )) }
            </div>
            <Pagination
              pageSize={ pageSize }
              total={ total }
              onChange={ (targetPage) => setPage(targetPage) }
              style={ { textAlign: 'right' } }
              className={styles.body_pagination}
            />
          </Card>
        </div>
        <div className={ styles.footer }></div>
      </Drawer>
    </div>
  );
};

export default DocumentDrawer;